import { gsap } from 'gsap';
import { state } from './state';

export const animate = component => {
  const content = component.querySelector(`.nav_primary-content`);
  const menu = component.querySelector('.nav_primary-nav_list');
  const menuItems = menu ? menu.querySelectorAll('.menu-item') : [];

  const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;

  if (state.isOpen) {
    gsap.to(content, {
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power2.out',
    });

    if (!state.hasAnimated) {
      state.hasAnimated = true;

      menuItems.forEach((item, index) => {
        const animationProps = isSmallScreen
          ? { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' }
          : { autoAlpha: 1, x: 0, duration: 0.5, ease: 'power2.out' };

        gsap.fromTo(
          item,
          {
            autoAlpha: 0,
            y: isSmallScreen ? 20 : 0,
            x: isSmallScreen ? 0 : 20,
          },
          {
            ...animationProps,
            delay: index * 0.1,
          },
        );
      });
    }
  } else {
    gsap.to(content, {
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.out',
    });

    menuItems.forEach(item => {
      gsap.set(item, {
        autoAlpha: 0,
        y: isSmallScreen ? 20 : 0,
        x: isSmallScreen ? 0 : 20,
      });
    });

    state.hasAnimated = false;
  }
};
